module.exports = __webpack_public_path__ + "img/ar-preview.134c088a.webp";